import { PartnerExportEmailRequestDto } from '@/models/Admin/Emails/EmailRequestDtos';
import { ProgramNames } from '@/models/Program';
import { isEmail } from '@/utils/emailUtil';
import React, { useEffect, useState } from 'react';
import PartnerExportForm from './PartnerExportForm';
import { PartnerExportSubmitState } from './types';

type Props = {
  onStateChange: React.Dispatch<React.SetStateAction<PartnerExportSubmitState>>;
  resetSignal: number;
};

const programOptions = Object.values(ProgramNames).filter(
  (value): value is ProgramNames => typeof value === 'number'
);

const createInitialForm = (): PartnerExportEmailRequestDto => ({
  Email: '',
  Program: ProgramNames.TreeCityUSA,
});

const createEmptySubmitState = (): PartnerExportSubmitState => ({
  request: createInitialForm(),
  isValid: false,
});

const PartnerExportSection: React.FC<Props> = ({ onStateChange, resetSignal }) => {
  const [form, setForm] = useState<PartnerExportEmailRequestDto>(createInitialForm());

  const isValid = form.Program != null && isEmail(form.Email);

  useEffect(() => {
    onStateChange({
      request: form,
      isValid,
    });
  }, [form, isValid, onStateChange]);

  useEffect(() => {
    setForm(createInitialForm());
    onStateChange(createEmptySubmitState());
  }, [onStateChange, resetSignal]);

  return <PartnerExportForm form={form} setForm={setForm} programOptions={programOptions} />;
};

export default PartnerExportSection;
